import { useState } from "react";
import { useTranslation } from "react-i18next";

const CodeViewer = ({ code }) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  // Split code into lines for line numbers
  const codeLines = code.split("\n");

  return (
    <div className="relative mx-auto mt-5 w-full max-w-3xl rounded-lg border bg-gray-700 shadow">
      {/* Copy Button */}
      <button
        onClick={handleCopy}
        className={`absolute left-2 top-2 rounded px-3 py-1 text-sm font-semibold ${
          copied ? "bg-green-500 text-white" : "bg-gray-800 text-gray-200"
        } transition`}
      >
        {copied ? t("copied") : t("copy")}
      </button>

      <div className="flex overflow-x-auto">
        {/* Line Numbers */}
        <div className="select-none bg-gray-800 px-2 py-4 text-right font-mono text-sm text-gray-400">
          {codeLines.map((_, idx) => (
            <div key={idx}>{idx + 1}</div>
          ))}
        </div>

        {/* Code Content */}
        <pre className="flex-1 overflow-x-auto p-4 font-mono text-sm text-gray-100">
          <code>
            {codeLines.map((line, idx) => (
              <div key={idx}>{line || "\u00A0"}</div> // \u00A0 ensures empty lines are visible
            ))}
          </code>
        </pre>
      </div>
    </div>
  );
};

export default CodeViewer;
